export default "__VITE_ASSET__c46a74f4__$_?component__"